<template>
  <Popup
    :show="props.modelValue"
    position="center"
    :close-on-click-overlay="props.closable"
    :lock-scroll="true"
    overlay-class="nov-dialog-overlay"
    :z-index="2000"
    class="nov-dialog-popup"
    :style="{ background: 'transparent' }"
    @update:show="onUpdateShow"
  >
    <div class="nov-dialog" :class="[cssType, $i18n.locale, `nov-dialog--${props.variant}`]" role="dialog" aria-modal="true" :aria-label="props.title || undefined">
      <div class="nov-dialog-title" v-if="props.title && props.variant === 'panel'">{{ props.title }}</div>
      <div class="nov-dialog-content" :class="{ 'no-title': !props.title }">
        <slot></slot>
      </div>
      <button
        type="button"
        class="nov-dialog-close"
        v-if="props.closable && (props.variant === 'panel' || props.showClose)"
        :aria-label="$t('novShopping.common.cancel')"
        @click="handleClose"
      ></button>
    </div>
  </Popup>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue'
import { Popup } from 'vant'
import { isMobile } from '@/utils'

const cssType = isMobile ? 'mobile' : 'pc'

const props = defineProps({
  variant: {
    type: String,
    default: 'plain',
    validator: (value) => ['plain', 'panel'].includes(value),
  },
  modelValue: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: '',
  },
  closable: {
    type: Boolean,
    default: true,
  },
  // 无标题底板按需复用黄色关闭按钮。
  showClose: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['update:modelValue'])

const onUpdateShow = (value) => {
  emit('update:modelValue', value)
}

const handleClose = () => {
  if (!props.closable) return
  emit('update:modelValue', false)
}
</script>

<style lang="less" scoped>
@import '../../styles/tokens.less';

// 通用基础样式，双端尺寸和底板在各自的样式文件中定义。
.nov-dialog {
  position: relative;
  box-sizing: border-box;
  width: 640px;
  max-width: calc(100vw - 40px);
  max-height: 80vh;
  border-radius: 18px;
  overflow: visible;
  background: @sp-dialog-bg;
  box-shadow: 0 0 0 3px #b9a6f0, 0 16px 40px rgba(50, 20, 120, 0.35);

  &.mobile {
    width: 620px;
    border-radius: 22px;
  }

  .nov-dialog-title {
    height: 64px;
    line-height: 64px;
    padding: 0 24px;
    text-align: center;
    font-size: 30px;
    font-weight: 800;
    color: #fff;
    background: @sp-dialog-head;
    border-radius: 15px 15px 0 0;
    text-shadow: 0 2px 0 rgba(80, 20, 140, 0.4);
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .nov-dialog-content {
    max-height: 62vh;
    padding: 28px 32px 30px;
    overflow-y: auto;
    font-size: 26px;
    color: #33323a;

    &.no-title {
      padding-top: 34px;
    }
  }

  .nov-dialog-close {
    padding: 0;
    border: 0;
    position: absolute;
    top: -18px;
    right: -18px;
    width: 46px;
    height: 46px;
    border-radius: 50%;
    background: @sp-dialog-close;
    box-shadow: 0 3px 0 rgba(190, 130, 0, 0.5);
    cursor: pointer;
    z-index: 2;

    &::before,
    &::after {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      width: 22px;
      height: 4px;
      border-radius: 2px;
      background: #fff;
    }

    &::before {
      transform: translate(-50%, -50%) rotate(45deg);
    }

    &::after {
      transform: translate(-50%, -50%) rotate(-45deg);
    }
  }

  &.mobile {
    .nov-dialog-title {
      height: 76px;
      line-height: 76px;
      font-size: 32px;
      border-radius: 19px 19px 0 0;
    }

    .nov-dialog-content {
      padding: 30px 28px 28px;
    }

    .nov-dialog-close {
      top: -16px;
      right: -10px;
      width: 52px;
      height: 52px;
    }
  }
}
</style>

<style lang="less" scoped src="./pc_style.less"></style>
<style lang="less" scoped src="./mobile_style.less"></style>

<style lang="less">
@import '../../styles/tokens.less';

.nov-dialog-overlay {
  background: @sp-dialog-overlay;
}

.nov-dialog-popup.van-popup--center {
  max-width: 100% !important;
  background: transparent;
  overflow: visible;
}
</style>
